import { FilterTypeKey, FilterType, INumberFilter, IStringFilter, IEnumFilter } from '../../components/filters-menu/filters';
import { Decisions } from '../../enums/decisions';
import { Statuses } from '../../enums/status';

export const jobFiltersWithRunInfo = new Map<FilterTypeKey, FilterType>([
	[
		'numberFilters',
		{
			max_retries: { columnName: 'Max Retries', cellKey: 'max_retries' },
			retry_timeout: { columnName: 'Retry Timeout', cellKey: 'retry_timeout' },
			refresh_rate: { columnName: 'Refresh Rate', cellKey: 'refresh_rate' },
			job_duration: { columnName: 'Job Duration', cellKey: 'job_duration' },
			retry_attempts: { columnName: 'Retry Attempts', cellKey: 'retry_attempts' },
		} as INumberFilter,
	],
	[
		'stringFilters',
		{
			name: { columnName: 'Name', cellKey: 'name' },
			task_classes: { columnName: 'Task', cellKey: 'task_classes' },
			start_time: { columnName: 'Start time', cellKey: 'start_time' },
			job_identifier: { columnName: 'Job Identifier', cellKey: 'job_identifier' },
			error_message: { columnName: 'Error Message', cellKey: 'error_message' },
			end_time: { columnName: 'End Time', cellKey: 'end_time' },
			next_run_time: { columnName: 'Next Run Time', cellKey: 'next_run_time' },
		} as IStringFilter,
	],
	[
		'enumFilters',
		{
			is_active: {
				columnName: 'Active',
				cellKey: 'is_active',
				enumOptions: [
					{ value: '1', label: 'Active' },
					{ value: '0', label: 'Paused' },
				],
				deletable: true,
			},
			run_on_init: {
				columnName: 'Run On Init',
				cellKey: 'run_on_init',
				enumOptions: [
					{ value: '1', label: Decisions.Yes },
					{ value: '0', label: Decisions.No },
				],
				deletable: true,
			},
			status: {
				columnName: 'Status',
				cellKey: 'status',
				enumOptions: [
					{ value: Statuses.Active, label: 'Active' },
					{ value: Statuses.Paused, label: 'Paused' },
					{ value: Statuses.NoBalance, label: 'No Balance' },
					{ value: Statuses.New, label: 'New' },
					{ value: Statuses.Ended, label: 'Ended' },
				],
				deletable: true,
			},
		} as IEnumFilter,
	],
]);

export const jobFiltersWithoutRunInfo = new Map<FilterTypeKey, FilterType>([
	[
		'numberFilters',
		{
			max_retries: { columnName: 'Max Retries', cellKey: 'max_retries' },
			retry_timeout: { columnName: 'Retry Timeout', cellKey: 'retry_timeout' },
			refresh_rate: { columnName: 'Refresh Rate', cellKey: 'refresh_rate' },
		} as INumberFilter,
	],
	[
		'stringFilters',
		{
			name: { columnName: 'Name', cellKey: 'name' },
			task_classes: { columnName: 'Task', cellKey: 'task_classes' },
		} as IStringFilter,
	],
	[
		'enumFilters',
		{
			is_active: {
				columnName: 'Active',
				cellKey: 'is_active',
				enumOptions: [
					{ value: '1', label: 'Active' },
					{ value: '0', label: 'Paused' },
				],
				deletable: true,
			},
			run_on_init: {
				columnName: 'Run On Init',
				cellKey: 'run_on_init',
				enumOptions: [
					{ value: '1', label: Decisions.Yes },
					{ value: '0', label: Decisions.No },
				],
				deletable: true,
			},
		} as IEnumFilter,
	],
]);
